import React from "react";
import et from "../../../assets/english-teacher.jpg";
import ed from "../../../assets/ed-logo.png";
import sociology from "../../../assets/sociology-zone-logo.svg";
import psycology from "../../../assets/psychology-zone-logo-blue.svg";

import { ReactComponent as MDLogo } from "../../../assets/math-logo.svg";
import { ReactComponent as EDLogo } from "../../../assets/english-logo.svg";
import { ReactComponent as SDLogo } from "../../../assets/science-logo.svg";
import config from "config";

const AcrossCard = () => {
  let friendCards = [];

  if (config["class-name"] === "math" || config["class-name"] === "english") {
    friendCards.push({
      name: "Science Directory",
      link: "https://sciencedirectory.co.uk",
      img: SDLogo,
    });
  }

  if (
    config["class-name"] === "science" ||
    config["class-name"] === "english"
  ) {
    friendCards.push({
      name: "Maths Directory",
      link: "https://mathsdirectory.co.uk",
      img: MDLogo,
    });
  }

  if (config["class-name"] === "science" || config["class-name"] === "math") {
    friendCards.push({
      name: "English Directory",
      link: "https://englishdirectory.co.uk",
      img: EDLogo,
    });
  }

  return (
    <div className="across-card">
      <div className="title">We are friends with</div>
      <div className="content-6">
        <a
          href="https://www.englishteacher.co.uk"
          className="card-anchor"
          target="_blank"
        >
          <div className="icon">
            <img src={et} alt="english-teacher" style={{ width: "80px" }} />
            <div>www.englishteacher.co.uk</div>
          </div>
        </a>
        <a
          href="https://www.englishdepartment.co.uk"
          className="card-anchor"
          target="_blank"
        >
          <div className="icon">
            <img
              src={ed}
              alt=""
              style={{ maxWidth: "220px", height: "37px" }}
            />
            <div>www.englishdepartment.co.uk</div>
          </div>
        </a>
        <a
          href="https://www.psychologyzone.co.uk"
          className="card-anchor"
          target="_blank" rel="noreferrer"
        >
          <div className="icon">
            <img src={sociology} alt="" style={{ maxWidth: "160px" }} />
            <div>www.sociologyzone.co.uk</div>
          </div>
        </a>
        <a
          href="https://www.sociologyzone.co.uk"
          className="card-anchor"
          target="_blank" rel="noreferrer"
        >
          <div className="icon">
            <img src={psycology} alt="" style={{ maxWidth: "160px" }} />
            <div>www.psychologyzone.co.uk</div>
          </div>
        </a>

        {friendCards.map((card, index) => {
          return (
            <a
              href={card.link}
              className="card-anchor"
              target="_blank"
              key={index}
            >
              <div className="icon">
                <div style={{ margin: 0, maxWidth: "320px", height: "57px" }}>
                  <card.img />
                </div>
                <div>{card.name}</div>
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default AcrossCard;
